var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoSmartphone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "12ADB1D5-3242-467C-9183-215CC6BD4691") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.99724996,16.6665 C9.99848084,16.6665 9.99931417,12.2228889 9.99974996,3.33566664 C9.99974996,3.33443606 7.77836107,3.33360273 3.33558329,3.33316664 C3.33463038,3.33316664 3.33379704,7.77677775 3.33308329,16.664 C3.33308329,16.6649529 5.55447218,16.6657862 9.99724996,16.6665 Z M9.99724996,18.3331666 L3.33558329,18.3331666 C2.41367933,18.3331666 1.66641663,17.5859039 1.66641663,16.664 L1.66641663,3.33566664 C1.66641663,2.41376268 2.41367933,1.66649997 3.33558329,1.66649997 L9.99724996,1.66649997 C10.919828,1.66649997 11.6664166,2.41360313 11.6664166,3.33566664 L11.6664166,16.664 C11.6664166,17.5860635 10.919828,18.3331666 9.99724996,18.3331666 Z M5.83308329,15.8331666 L7.49974996,15.8331666 L7.49974996,14.1665 L5.83308329,14.1665 L5.83308329,15.8331666 Z M13.2502971,8.0857479 L14.3127023,6.80158556 C15.266983,7.59107512 15.8331663,8.74705595 15.8331663,9.99950004 C15.8331663,11.2520384 15.267691,12.4068511 14.3135613,13.1983695 L13.2494381,11.9156305 C13.8292242,11.4346567 14.1664997,10.7458732 14.1664997,9.99950004 C14.1664997,9.25363044 13.8289687,8.5644909 13.2502971,8.0857479 Z M16.1823328,15.4568493 L15.1191662,14.1733173 C16.3547147,13.149896 17.0832494,11.6349757 17.0832494,10.0000833 C17.0832494,8.36472646 16.355015,6.85043049 15.118937,5.82582607 L16.182562,4.54267383 C17.7965125,5.88050279 18.7499161,7.86301688 18.7499161,10.0000833 C18.7499161,12.1367808 17.7961066,14.1201391 16.1823328,15.4568493 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vesion02",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03-Sixtbook_Profile",
    transform: "translate(-1183.000000, -307.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Contact-Info",
    transform: "translate(0.000000, 71.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(1150.000000, 49.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/24x24/ico_smartphone",
    transform: "translate(32.000000, 186.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#FF5000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSmartphone);
export default __webpack_public_path__ + "static/media/ico_smartphone.b527e93e594ee7239d1464bc2580d878.svg";
export { ForwardRef as ReactComponent };